import { SelectInput as SelectInputZebra } from '@trmediaab/zebra-components';
import type { PartiallyRequired } from '@trmediaab/zebra-types/utils';

import { RenderInput } from './RenderInput';

export interface SelectInputProps
  extends PartiallyRequired<
    React.ComponentProps<typeof SelectInputZebra>,
    'value' | 'name' | 'data' | 'onChange'
  > {
  label?: string;
  description?: string;
}

export const SelectInput = ({
  label,
  description,
  name,
  value,
  data,
  width,
  onChange,
  ...props
}: SelectInputProps) => (
  <RenderInput
    label={label}
    description={description}
    render={id => (
      <SelectInputZebra
        id={id}
        name={name}
        value={value}
        data={data}
        width={width}
        height="buttonHeights.xlarge"
        pl="3"
        selectStyles={{
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: 'border.primary',
          borderRadius: 1,
        }}
        indicatorStyles={{
          width: '34px',
          iconType: 'triangle',
          color: 'checkout.selectIndicator',
          bg: 'checkout.selectIndicatorBg',
        }}
        onChange={onChange}
        {...props}
      />
    )}
  />
);
